<template>
  <div>
    <b-table
      ref="table"
      fixed
      hover
      selectable
      select-mode="multi"
      @row-selected="onRowSelected"
      foot-clone
      small
      :fields="fields"
      :items="items"
    >
      <template v-slot:cell(action)="data">
        <b-col cols="12" sm="12" md="12" lg="12">
          <a
            href="#"
            v-if="!data.item.selected"
            @click.prevent="editRow(data.item)"
            class="text-black-50"
            ><i class="fa fa-edit fa-lg mr-2" />
          </a>
          <a
            href="#"
            @click.prevent="printLabel(data.item)"
            class="text-black-50"
            ><i class="fa fa-print fa-lg mr-2"></i>
          </a>
          <a
            href="#"
            @click.prevent="deleteRow(data.item)"
            class="text-black-50"
            ><i class="fa fa-close text-danger fa-lg mr-2"></i>
          </a>
          &nbsp;
        </b-col>
      </template>

      <!-- Default fall-back custom formatted footer cell -->
      <template v-slot:foot()="data"> </template>

      <template v-slot:cell(net_weight)="{ item }">
        {{ item.net_weight | num_format }}
      </template>

      <template v-slot:cell(gross_weight)="{ item }">
        {{ item.gross_weight | num_format }}
      </template>

      <template v-slot:foot(quantity)="data">
        <span>{{ totalQuantity }}</span>
      </template>

      <template v-slot:foot(net_weight)="data">
        <span>{{ totalNet | num_format }}</span>
      </template>

      <template v-slot:foot(idx)="data">
        <span>{{ completedPallet }}</span>
      </template>
    </b-table>
    {{ selected.length }}

    <set-pallet :selected="selectedRow"></set-pallet>
    <print-modal ref="printContent" :form="form"></print-modal>
  </div>
</template>

<script>
import setPallet from "./SetPallet";
import printModal from "../../printModal";
import { mapState, mapActions, mapGetters } from "vuex";
import numeral from "numeral";
import { bus } from "../../../main.js";

export default {
  name: "createContentTable",
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  components: {
    setPallet,
    printModal
  },
  created() {
    bus.$on("clearSelectedRows", () => {
      this.$refs.table.clearSelected();
    });
  },
  data() {
    return {
      fields: [
        { key: "idx", label: "#" },
        { key: "lot", label: "Lote" },
        { key: "code", label: "Código" },
        { key: "description", label: "Producto" },
        { key: "quantity", label: "Cantidad" },
        { key: "net_weight", label: "KN" },
        { key: "gross_weight", label: "KB" },
        { key: "action", label: "" }
      ],
      selectedRow: {
        idx: null,
        lot: null,
        code: null,
        description: null,
        product: null,
        quantity: null,
        gross_weight: null,
        net_weight: null
      }
    };
  },
  computed: {
    ...mapState("bagnoArrivalModule", ["items", "selected"]),
    ...mapGetters("bagnoArrivalModule", [
      "totalNet",
      "totalQuantity",
      "completedPallet",
      "itemsSelectedCount"
    ])
  },
  filters: {
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  methods: {
    handleClearSelection(evt) {
      this.$store.dispatch("bagnoArrivalModule/clearSelected");
      this.$refs.table.clearSelected();
    },
    onRowSelected(items) {
      const limit = 3;
      let selected = items;
      if (this.items.length > limit) {
        selected = items.slice(0, limit);
      }
      const toUnselected = items.slice(limit);
      toUnselected.forEach(item => {
        const idx = this.items.findIndex(it => item == it);
        if (idx >= 0) {
          this.$refs.table.unselectRow(idx);
        }
      });
      this.$store.dispatch("bagnoArrivalModule/addRowsToSelected", items);
    },
    printLabel(row) {
      if (row.net_weight === null) {
        this.$toast.info(
          "Para imprimir debe ingresar el detalle (Cantidad,KN,KB)",
          ""
        );
      } else {
        this.$refs.printContent.modalShown = true;
        this.$refs.printContent.contentPrint = row;
      }
    },
    editRow(row) {
      this.$bvModal.show("modal-pallet");
      this.selectedRow = row;
    },
    deleteRow(row) {
      this.items;
      this.$store.dispatch("bagnoArrivalModule/removeRows", row);
    }
  },
  mounted() {
    this.$store.dispatch("bagnoArrivalModule/removeAll");
  }
};
</script>

<style scoped></style>
